export type DeliveryChannel = 'EMAIL' | 'SMS' | 'WHATSAPP';

export interface DeliverySigner {
    name: string;
    role: string;
    govTaxId: string;
    phoneMasked: string | null;
    hasPhone: boolean;
}

export interface DeliveryChannelChoice {
    govTaxId: string;
    role: string;
    channel: DeliveryChannel;
}

export const deliveryKeyOf = (signer: Pick<DeliverySigner, 'govTaxId' | 'role'>): string => `${signer.govTaxId}|${signer.role}`;

export const buildDeliveryChannelsPayload = (
    signers: DeliverySigner[],
    choices: Record<string, DeliveryChannel>,
    supportsPhoneDelivery: boolean,
): DeliveryChannelChoice[] =>
    signers.map((signer) => ({
        govTaxId: signer.govTaxId,
        role: signer.role,
        channel: supportsPhoneDelivery ? choices[deliveryKeyOf(signer)] ?? 'EMAIL' : 'EMAIL',
    }));
